module.exports = __webpack_public_path__ + "img/no_data_events.29b83188.svg";